var lazyImage = function(){
	var $ = require("jquery"),
	moduleName = "lazy-image",
	module = $("." + moduleName);
	if (module.length < 1){
		return false
	};
	var LazyLoad = require("vanilla-lazyload"),
	preloader = require('../preloader/preloader');
	module.each(function(){
		newLazy = new LazyLoad({
			container: this,
			elements_selector: "." + moduleName + " img",
			callback_enter: function(pic){
				new preloader.init({
					parent: pic.parentNode
				})
			},
			callback_load: function(pic){
				new preloader.remove({
					parent: pic.parentNode
				})
			},
			callback_error: function(err){
				console.log(err)
			}
		});
	})
	

};
module.exports = lazyImage